import { Steps } from "antd";
const Step = Steps.Step;
import "./index.less";
import middleware from "../../middleware";

class main extends React.Component {
  static Step = Step;
  render() {
    const { direction = "" } = this.props;
    //竖向
    if (direction == "vertical") {
      return <Steps {...this.props} />;
    } else {
      //横向
      return <Steps className="wea-steps" {...this.props} />;
    }
  }
}

const Com = middleware(main, "WeaSteps");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-steps/index.js